export default {
  camelize(str) {
    return str
      .replace(
        /(?:^\w|[A-Z]|\b\w)/g,
        (letter, index) =>
          index === 0
            ? letter.toLowerCase()
            : letter.toUpperCase(),
      )
      .replace(/\s+/g, '');
  },

  capitalize(str) {
    return str
      .replace(
        /(?:^\w|[A-Z]|\b\w)/g,
        (letter, index) =>
          index === 0 ? letter.toUpperCase() : letter,
      )
      .replace(/\s+/g, '');
  },

  literalJoin(arg, all, last) {
    let arr = arg.slice();
    const lastItem = arr.splice(-1);
    arr = arr.length ? [arr.join(all)] : [];
    arr.push(lastItem);
    return arr.join(last);
  },
};



// WEBPACK FOOTER //
// ./src/shared/utils/string-utils.js